import React, { Component } from 'react';
import { Grid, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import { send_request } from '../../utils/Request';
import FadeIn from 'react-fade-in';
import DeleteDialog from './DeleteDialog';
import ImportDialog from './ImportDialog';
import MarketplaceCard from './MarketplaceCard';
import usePreviewStore from '../ProjectCanvas/usePreviewStore';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import './MarketplacePage.css';
import LinkDialog from './LinkDialog';

import PageCardsSkeleton from '../../utils/PageCardsSkeleton';
import { withParams } from '../../Routes';
const styles = theme => ({});
import { styled } from '@mui/material/styles';
import PageLayout from '../common/PageLayout';
import PageTopBar from '../common/PageTopBar';
import PageFilters from '../common/PageFilters';

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: '8px',
  '& .MuiGrid-item': {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

const GridContainer = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  width: 100%;
`;

class MarketplacePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      importsv: false,
      request: false,
      importSuccess: false,
      tab: 0,
      allTemplates: [],
      dataImport: null,
      dataDelete: null,
      confirmDelete: false,
      loadImport: false,
      searchTemplates: [],
      searchPrivateTemplates: [],
      disableRemove: false,
      openLinkDialog: false,
      activeTemplate: {},
      loading: false,
      cloneProjectId: '',
      categorySelected: 0,
      searchText: '',
      categories: [],
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });

    const [allTemplates, categories] = await Promise.all([
      this.requestMarketplace(),
      this.requestCategories(),
    ]);

    this.setState({
      allTemplates: allTemplates,
      searchTemplates: allTemplates,
      categories: categories,
      loading: false,
    });

    if (usePreviewStore.getState().download) {
      this.setState({ dataImport: usePreviewStore.getState().template });

      this.requestTemplateToProject();
    }
  }

  requestMarketplace = async () => {
    const json = await send_request('project-service/template/getProjectTemplates', '', {}).catch(
      err => {
        let url = '/ ';

        window.open(url, '_self');
        throw Error(err.message);
      }
    );

    if (json && json.data) return json.data;
    return [];
  };

  requestCategories = async () => {
    const response = await send_request(
      'project-service/template/projectCategories',
      '',
      {},
      'GET'
    ).catch(err => {
      console.log(err);
      return { data: [] };
    });

    return response.data || [];
  };

  handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
  };

  requestTemplateToProject = async () => {
    this.setState({ loadImport: true });
    const { dataImport } = this.state;
    if (!dataImport) return false;

    const requestData = {
      projectId: dataImport.projectId,
      version: dataImport.version,
    };
    const { importSuccess, importsv } = this.state;
    const json = await send_request(
      'project-service/template/templatetoproject',
      requestData,
      '',
      'POST'
    ).catch(err => {
      throw Error(err.message);
      this.setState({ loadImport: false });
    });

    if (json && json.status == 200) {
      this.setState({
        importSuccess: !importSuccess,
        importsv: !importsv,
        cloneProjectId: json.data,
        loadImport: false,
      });
      const allTemplates = await this.requestMarketplace();

      this.setState({
        allTemplates: allTemplates,
        searchTemplates: allTemplates,
      });

      usePreviewStore.setState({ download: false });
      this.props.navigate(`/project/canvas/${this.state.cloneProjectId}`);

      return true;
    }
    return false;
  };

  requestDeleteTemplate = async () => {
    const { dataDelete } = this.state;
    if (!dataDelete) return false;

    const requestData = {
      projectId: dataDelete.projectId,
      version: dataDelete.version,
    };
    this.setState({ disableRemove: true });
    const json = await send_request(
      'project-service/template/delete',
      requestData,
      '',
      'POST'
    ).catch(err => {
      throw Error(err.message);
    });

    if (json && json.status == 200) {
      const allTemplates = await this.requestMarketplace();

      this.setState({
        allTemplates: allTemplates,
        searchTemplates: allTemplates,
        disableRemove: false,
      });

      return true;
    }
    return false;
  };

  confirmDelete = async () => {
    const { confirmDelete } = this.state;
    const del = await this.requestDeleteTemplate();
    if (del) {
      const data = await this.requestMyTemplates();
      this.setState({
        confirmDelete: !confirmDelete,
      });
    }
    this.componentDidMount();
  };

  handleCategoryChange = category => {
    this.setState({ categorySelected: category });
    this.filterTemplates(this.state.searchText, category);
  };

  handleSearch = e => {
    const searchText = e.target.value;
    this.setState({ searchText });
    this.filterTemplates(searchText, this.state.categorySelected);
  };

  handleClearSearch = () => {
    this.setState({ searchText: '' });
    this.filterTemplates('', this.state.categorySelected);
  };

  filterTemplates = (searchText, categorySelected) => {
    const { searchTemplates } = this.state;
    const word = searchText.toLowerCase();

    searchTemplates.map(i => (i.name === null ? (i.name = 'Untitled') : (i.name = i.name)));
    const allTemplates = this.state.searchTemplates.filter(
      item =>
        (word === '' ||
          item.name.toLowerCase().includes(word) ||
          item.author.toLowerCase().includes(word)) &&
        (categorySelected !== 0
          ? item.categories && item.categories.includes(categorySelected)
          : true)
    );

    this.setState({
      allTemplates: allTemplates,
    });
  };

  render() {
    const { importsv, request, importSuccess, tab, allTemplates, confirmDelete } = this.state;

    const categoryFilters = [
      {
        key: 'category',
        type: 'select',
        label: 'Category',
        options: [
          { value: 0, label: 'All Categories' },
          ...this.state.categories.map(cat => ({
            value: cat.categoryId,
            label: cat.displayName,
          })),
        ],
      },
    ];

    return (
      <PageLayout
        title={'Workflow templates'}
        contentSx={{ px: 2, pb: 2, pt: 2 }}
        titleBarContent={
          <PageTopBar
            searchValue={this.state.searchText}
            onSearchChange={this.handleSearch}
            onClearSearch={this.handleClearSearch}
            searchPlaceholder="Search for a template..."
            sx={{
              p: 0,
              border: 'none',
              backgroundColor: 'transparent',
              minHeight: 'auto',
              gap: 1,
              width: '100%',
              '& .MuiTextField-root': {
                flex: 1,
                maxWidth: 'none',
                '& .MuiOutlinedInput-root': {
                  height: '32px',
                  fontSize: '0.875rem',
                },
              },
            }}
          >
            <PageFilters
              filters={categoryFilters}
              activeFilters={{ category: this.state.categorySelected }}
              onFilterChange={(key, value) => this.handleCategoryChange(value)}
            />
          </PageTopBar>
        }
      >
        {!this.state.loading ? (
          <Box>
            <GridContainer>
              {allTemplates &&
                allTemplates.map((template, index) => (
                  <FadeIn key={index}>
                    <MarketplaceCard template={template} />
                  </FadeIn>
                ))}
            </GridContainer>
          </Box>
        ) : (
          <PageCardsSkeleton
            count={12}
            rowGap="16px"
            columnGap="16px"
            skeletonStyles={{
              width: '320px',
              minHeight: '200px',
            }}
          />
        )}
        <DeleteDialog
          disableRemove={this.state.disableRemove}
          confirmDelete={confirmDelete}
          delete={() => {
            this.confirmDelete();
          }}
          close={() => {
            this.setState({ confirmDelete: !confirmDelete });
          }}
        />
        <LinkDialog
          open={this.state.openLinkDialog}
          id={this.state.activeTemplate.projectId}
          handleClose={() => {
            this.setState({ openLinkDialog: false });
          }}
        />
        <ImportDialog
          importSuccess={importSuccess || this.state.loadImport}
          dataImport={this.state.dataImport}
          importsv={importsv}
          loadImport={this.state.loadImport}
          handleCancel={() => this.setState({ importsv: !importsv })}
          importTemplateToProject={() => {
            this.requestTemplateToProject();
          }}
          close={() => {
            this.setState({ importsv: !importsv });
          }}
          close2={() => {
            this.setState({ importSuccess: !importSuccess });
          }}
          goToProjects={() => {
            this.setState({ importSuccess: !importSuccess });
            usePreviewStore.setState({ download: false });
            this.props.navigate('/project/canvas/' + this.state.cloneProjectId);
          }}
          handleDone={() => {
            this.setState({ importSuccess: !importSuccess });
            usePreviewStore.setState({ download: false });
          }}
        />
      </PageLayout>
    );
  }
}

export default withParams(withStyles(styles)(MarketplacePage));
